import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { Link } from '@tanstack/react-router';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { ColorModeContext } from '../../theme';
import { useAuth } from '../../hooks/useAuth';
import { APP_HEADER_HEIGHT } from './appHeader';

import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';

export const PublicLayout = ({ children }: { children: React.ReactNode }) => {

    const theme = useTheme()
    const colorMode = React.useContext(ColorModeContext);
    const { user, login } = useAuth();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Box component="header" sx={{
                position: 'sticky', top: 0, zIndex: 'appBar',
                height: APP_HEADER_HEIGHT, boxSizing: 'border-box',
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between',
                px: 4,
                borderBottom: 1, borderColor: 'divider',
                bgcolor: 'banner.main'
            }}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <Typography variant="h3" sx={{ fontWeight: 700, color: 'primary.main' }}>CliZod</Typography>
                </Link>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton onClick={colorMode.toggleColorMode} sx={{ color: 'banner.contrastText' }}>
                        {theme.palette.mode === "dark" ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
                    </IconButton>
                    {user
                        ? <Button component={Link} to="/dashboard" variant="outlined">Reviews</Button>
                        : <Button onClick={() => void login({ redirectUri: `${window.location.origin}/dashboard` })} variant="outlined">Sign In</Button>
                    }
                </Box>
            </Box>
            <Box component="main" sx={{ flex: 1 }}>
                {children}
            </Box>
        </Box>
    );
}
